export const GetBackendUrl: ()=>string = () => {
    return "https://fridalifdev.ru";
}
